import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
/**
 * Dropdown bound to the active rows of `/api/currencies`. Use anywhere a
 * 3-letter ISO 4217 code is needed. Loads once and caches via React Query.
 */
export function CurrencyPicker({ name, value, onChange, required, disabled, className, }) {
    const q = useQuery({
        queryKey: ["currencies"],
        queryFn: () => api.get("/currencies"),
        staleTime: 1000 * 60 * 60, // an hour
    });
    return (_jsxs("select", { name: name, required: required, disabled: disabled || q.isLoading, value: value, onChange: (e) => onChange?.(e.target.value), className: className ?? "input font-mono uppercase", children: [q.data?.map((c) => (_jsxs("option", { value: c.code, children: [c.code, " \u2014 ", c.name] }, c.code))), !q.data && value && _jsx("option", { value: value, children: value })] }));
}
